import { initializeApp } from 'firebase/app'
require('dotenv').config()

const app = initializeApp({
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FB_APP_ID,
})

/* 
if (process.env.REACT_APP_USE_EMULATOR) {
  firebase.auth().useEmulator('localhost:9099')
  firebase.firestore().useEmulator('localhost', 8080)
  firebase.storage().useEmulator('localhost', 9199)
}
 */

export default app
